const getters = {
	userToken(state) {
		return state.userToken;
	},

	userName(state) {
		return state.userName;
	},

	userId(state) {
		return state.userId;
	},

	isLogin(state) {
		return state.isLogin;
	},

	balance(state) {
		return state.balance;
	},

	photo(state) {
		return state.photo;
	}
};

export default getters